module.exports = __webpack_public_path__ + "static/assets/9ce846b427193dfc81e99f6495b535ce.png";